import type { ItemProps } from './types';
import * as React from 'react';

interface ItemContextArguments extends Partial<ItemProps> {
  type: 'popover' | 'dialog' | 'icon' | 'sheet';
  responsive?: boolean;
}

export const ItemContext = React.createContext<ItemContextArguments>({
  type: 'popover',
  responsive: false,
});

export const ItemContextProvider = ItemContext.Provider;

export const useItemContext = () => React.useContext(ItemContext) as ItemProps;
